export const capitalizeFirstLetter = (string) => {
    return string.toLowerCase().charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};

export const isEmpty = (value) => {
    return (typeof value === 'string' && value?.trim().length === 0) || value === '-' || value === null || value === undefined;
};

export const parseStringToJson = (string) => {
    try {
        return JSON.parse(string);
    } catch (e) {
        return null;
    }
}